/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button } from "@nordcloud/gnui";
import { showSuccess } from "~/components/Toast";
import { RequestTableItem } from "~/models/services";
import { generateActionSuccessText, useAxios } from "~/tools";
import { ServiceViewCtx } from "~/views/services/details/ServiceViewCtx";
import EditRequestSidebar from "./EditRequestSidebar";

type Props = {
  request: RequestTableItem;
};

export default function ({ request }: Props) {
  const { refetch } = React.useContext(ServiceViewCtx);

  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const { Axios } = useAxios();

  const editRequest = async (values: any) => {
    await Axios().patch(`/requests/${request.id}`, values);
    showSuccess(
      generateActionSuccessText(`Request ${values.name}`)()("updated")()
    );

    return refetch();
  };

  return (
    <>
      <Button
        icon="edit"
        size="sm"
        onClick={() => setIsSidebarOpen(true)}
        severity="low"
        marginRight="8px"
      >
        Edit
      </Button>

      <EditRequestSidebar
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        editedRequest={request}
        onSubmit={editRequest}
      />
    </>
  );
}
